import {Component, Input, OnInit} from '@angular/core';
import {ChangeHistory, IncidentRecord} from "../../../NIBINInterface";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {DropdownService} from "../../../services/dropdown.service";
import {IncidentService} from "../../../services/incident.service";
import {ReportService} from "../../../services/report.service";
import {DownloadService} from "../../../services/download.service";
import {DataChangeRequestService} from "../../../services/DataChangeRequest.service";

@Component({
  selector: 'app-change-history-view',
  templateUrl: './change-history-view.component.html',
  styleUrls: ['./change-history-view.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [DropdownService, IncidentService, ReportService, DownloadService, DataChangeRequestService]
})
export class ChangeHistoryViewComponent implements OnInit {

  @Input("ChangeHistory") ChangeHistoryList:ChangeHistory[] = [];
  constructor() { }

  ngOnInit(): void {
  }


}
